/**
 * Where the invite token lives between the link and the accept call.
 *
 * The link carries it in the fragment (`/invite/accept#token=`) so it never reaches a
 * server log or a Referer header. It is parked in sessionStorage across sign-in and
 * cleared once the invitation reaches a final answer.
 */

export const INVITE_ACCEPT_PATH = "/invite/accept";
const STORAGE_KEY = "invite_accept_token";

export function readInviteToken(hash: string | null | undefined): string | null {
  const raw = String(hash || "").replace(/^#/, "");
  const token = new URLSearchParams(raw).get("token");
  return token && token.trim() ? token.trim() : null;
}

export function stashInviteToken(token: string): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, token);
  } catch {
    // Storage blocked: the token still works for this page load.
  }
}

export function peekStashedInviteToken(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function clearStashedInviteToken(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Nothing to clear.
  }
}

/** Only the accept page may be a post-login destination, so `next` is not an open redirect. */
export function safeReturnPath(next: string | null | undefined): string | null {
  return next === INVITE_ACCEPT_PATH ? INVITE_ACCEPT_PATH : null;
}

export function authPathForInvite(page: "/login" | "/register"): string {
  return `${page}?next=${encodeURIComponent(INVITE_ACCEPT_PATH)}`;
}
